import { memo } from 'react'

import { Outlet } from '@tanstack/react-router'

const AppShellRaw = () => {
  return <Outlet />
}

export const AppShell = memo(AppShellRaw)
